import { useEffect, useState } from 'react';
import axios from 'axios';
import { ytEmbedUrl } from '../lib/youtube';

export function YouTubeLive() {
  const [url, setUrl] = useState('');

  useEffect(() => {
    const load = () =>
      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/api/settings/youtube`)
        .then((r) => setUrl(r.data.url || ''))
        .catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const embed = ytEmbedUrl(url);
  if (!embed) return null;

  return (
    <section className="px-4 py-14 md:px-12" data-testid="youtube-live-section">
      <div className="mb-6 flex items-center gap-3">
        <span className="flex items-center gap-2 bg-[#D8232A] px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.25em] text-white">
          <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-white" /> Live Now
        </span>
        <h2 className="font-display text-lg uppercase tracking-[0.2em] text-white md:text-xl">
          Watch The Draw
        </h2>
      </div>
      <div className="mx-auto max-w-4xl border border-[#D4AF37]/30 bg-black">
        <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
          <iframe
            src={embed}
            title="Golden Raja Live Draw"
            className="absolute inset-0 h-full w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="youtube-live-iframe"
          />
        </div>
      </div>
    </section>
  );
}
